import axios from '@/services/DefaultApi';
import { getGlobalToast } from '@/toast';

const API_URL = 'dashboards';

class DashboardService {
  constructor() {
    this.toast = getGlobalToast();
  }

  async getDashboardLeads() {
    const path = 'leads';
    try {
      const response = await axios.get(`${API_URL}/${path}`);
      return response;
    } catch (error) {
      if (error.response) {
        return error.response;
      } else {
        // handleError(error);
      }
    }
  }

  async getDashboardJobcard() {
    const path = 'job-cards';
    try {
      const response = await axios.get(`${API_URL}/${path}`);
      return response;
    } catch (error) {
      if (error.response) {
        return error.response;
      } else {
        // handleError(error);
      }
    }
  }

  async getAddress() {
    const path = 'configuration-setup/ADDRESS?size=10&page=0';
    try {
      const response = await axios.get(`${path}`);
      return response.data;
    } catch (error) {
      if (error.response) {
        return error.response;
      } else {
        // handleError(error);
      }
    }
  }
}

export default new DashboardService();
